import Vue from 'vue'
import BlockCart from '@/components/BlockCart/BlockCart.vue'
import {ready} from '@/shared'
// require('@/shared/ajax-cart.js')

ready(function () {
  window.VueBlockCart = new Vue({ // eslint-disable-line no-new
    el: '#js-blockcart',

    components: {
      BlockCart
    },

    render: h => h('BlockCart')
  })
})



// WEBPACK FOOTER //
// ./src/blockcart.js